<style>
.img-fluid{
cursor: pointer;
}

.centered-link{
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  font-size: 0.9em;
  text-align: center;
}

.slick-slider[data-v-3d1a4f76] {
width: 60%;

}

.col-lg-7 {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.slick-slide img[data-v-e4caeaf8] {
    display: block;
}
.data-v-e4caeaf8{
  width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.slick-arrow {
  font-size: 24px;
  color: #333;
  z-index: 10;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.slick-arrow:hover {
color: #045C68;

}

.slick-prev {
  font-size: 3em;
  left: -30px;
}

.slick-next {

  font-size: 3em;
  right: -30px;
}
</style>

<template>
  <div id="lactationedn-view">
    <head>
      <meta name="description" content="ResMed Masks">
    </head>
    <section class="bg-light ftco-section">
      <div class="container" style="min-width: 90vw;">
        <h1 class="display-4 text-center  my-4">RESMED CPAP MASKS<br>
        <Span style="font-size: 0.3em;">(prescription required)</Span>
        </h1>
        <div class="row  my-5">
          <div class="col-md-12 col-lg-7">
            <VueSlickCarousel 
            ref="mainSlider">
        <div v-for="image in images" :key="image.id">
          <img :src="image.src" :alt="image.alt" class="img-fluid" />
        </div>
        <template v-slot:prevArrow>
        <button class="slick-arrow slick-prev">
          <i class="fas fa-chevron-left"></i>
        </button>
      </template>
      <template v-slot:nextArrow>
        <button class="slick-arrow slick-next">
          <i class="fas fa-chevron-right"></i>
        </button>
      </template>
      </VueSlickCarousel>
      <VueSlickCarousel
        :slides-to-show="5"
        :focus-on-select="true"
        :as-nav-for="$refs.mainSlider"
        class="mt-2"
      >
        <div v-for="image in images" :key="image.id">
          <img :src="image.thumbnail" :alt="image.alt" class="img-fluid" />
        </div>
      </VueSlickCarousel>
          </div>
          <div class="col-md-12 col-lg-5">
            <h3 class="mt-5 mb-2 text-light1">AirFit F10 Full Face Mask for Her</h3>
            <div class="row mb-4">
              <div class="col">
                <span class="text3">Description</span>
              </div>
            </div>

            <p>
                The ResMed AirFit F10 Full Face Mask enhances user comfort and compliance for CPAP users through its ease of use. It includes user-friendly features like detachable headgear straps and a quick-release elbow, simplifying tube disconnection. The AirFit F10 is designed with a sleek profile for unobstructed vision, and comes with cushioned headgear and robust cushion seals. These features ensure a quiet, stable seal all night long.

            </p>
            <div class="row mb-4">
              <div class="col">
                
              </div>
            </div>
            
              <div id="action-buttons" class="d-flex justify-content-between">
    <router-link to="/cpapform" class="btn btn-light mt-3" style="white-space: normal; font-size: 13px !important;" tag="button">
      Purchase with insurance
    </router-link>
  </div>

          </div>
        </div>
        <div class="row my-5">
  <div class="col-md-6">
    <h3 class="mt-5 mb-2 text-light1">Features</h3>
    <ul>
      <li>
        Offers Minimal Contact on Face and Easy Assembly
      </li>
      <li>
        Dual–Wall Cushion Provides Double the Benefits
      </li>
      <li>
        Pick Your Fit on Your Pink–Hued Headgear with Adjustable Feature
      </li>
      <li>
        Fewer Mask Materials Adds Up to an Open View for T.V. Watching
      </li>
      <li>
        Circular Vent at Quick–Release Elbow Quiets Your Night
      </li>
    </ul>
  </div>
  <div class="col-md-6">
    <h3 class="mt-5 mb-2 text-light1">In The Box</h3>
    <ul>
        <li>
    Spring Air Cushion
      </li>
      <li>
        Mask Frame
      </li>
      <li>
        Elbow
      </li>
      <li>
        Headgear
      </li>
      <li>
        Soft Strap Wraps
      </li>

    </ul>
  </div>
</div>

      </div>

      
    </section>
  </div>


  
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {

  components: {
    VueSlickCarousel,
  },
  data() {
  return {
    images: [
    { id: 1, src: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/1.webp'), thumbnail: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/1.webp'), alt: 'Image 1' },
    { id: 2, src: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/2.webp'), thumbnail: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/2.webp'), alt: 'Image 2' },
    { id: 3, src: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/3.webp'), thumbnail: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/3.webp'), alt: 'Image 3' },
    { id: 4, src: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/4.webp'), thumbnail: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/4.webp'), alt: 'Image 4' },
    { id: 5, src: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/5.webp'), thumbnail: require('@/assets/site/CPAP/AirFitF10FullFaceMaskforHer/5.webp'), alt: 'Image 5' },

    ],
  }
},
mounted() {
  this.$nextTick(() => {
    const arrows = this.$el.querySelectorAll('.slick-arrow');
    arrows.forEach(arrow => {
      arrow.addEventListener('click', () => {
        arrow.blur();
      });
    });
  });
}

}
</script>
